var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import calculateFontSizeforFooterButtons from "../../../../helpers/calculateFontSizeforFooterButtons";
import { IconButtonWrap } from "./IconButton.styles";
var IconButton = function (_a) {
    var title = _a.title, dataReason = _a.dataReason, className = _a.className, handleClick = _a.handleClick, buttonProps = _a.buttonProps, isStacked = _a.isStacked, activeIcon = _a.activeIcon, _b = _a.isDropdownItem, isDropdownItem = _b === void 0 ? false : _b, restIcon = _a.restIcon, id = _a.id, isOnlyOneButtonPresent = _a.isOnlyOneButtonPresent;
    return (_jsx(IconButtonWrap, __assign({}, buttonProps, { isStacked: isStacked, onClick: handleClick, "data-reason": dataReason, "data-type": "account card", "data-analytics": "clicktrackingevent", "data-object": "button", className: className, isDropdownItem: isDropdownItem, isOnlyOneButtonPresent: isOnlyOneButtonPresent, type: "button", id: id, buttonText: title, activeIcon: activeIcon, restIcon: restIcon, fontSize: calculateFontSizeforFooterButtons(isOnlyOneButtonPresent, isDropdownItem) })));
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map